import { genericApi } from '../utils/api';
import { API_URL } from '../utils/global';
import { setColor } from './ContextAction';
import store from './store';
import { IFRAME, MAIN, MODULE } from './types/MainActionTypes';
import Mustache from 'mustache';

const SL_MAIN_BACKEND_GET_APP_DESIGN_URL = '/sl_main_backend/get_app_design/';
const SL_MAIN_BACKEND_GET_MAIN_DESIGN_URL = '/sl_main_backend/get_main_design/';

export const buildAppFromHash = (hash) => {
  if (!hash || hash.split('/').length <= 1) {
    return '';
  }
  const segment = hash.split('/')[1].split('?')[0];
  return segment === '_MOD' ? '' : segment;
};

export const extractModuleAndNavItemsFromHash = (hash) => {
  let module = null;
  let navItems = null;

  if (hash && hash.includes('/_MOD/')) {
    let parts = hash.split('/_MOD/');
    let restOfPath = parts[1];

    let firstSlashIndex = restOfPath.indexOf('/');
    if (firstSlashIndex !== -1) {
      module = restOfPath.substring(0, firstSlashIndex);
      navItems = restOfPath.substring(firstSlashIndex + 1);
    } else {
      let firstQuestionMarkIndex = restOfPath.indexOf('?');
      if (firstQuestionMarkIndex !== -1) {
        module = restOfPath.substring(0, firstQuestionMarkIndex);
        navItems = restOfPath.substring(firstQuestionMarkIndex);
      } else {
        module = restOfPath;
      }
    }
  }

  return { module, navItems };
};

const serializeQueryParams = (paramsObj) => {
  return Object.entries(paramsObj)
    .map(([key, value]) => {
      const serialized =
        value !== null && typeof value === 'object'
          ? JSON.stringify(value)
          : value;
      return `${encodeURIComponent(key)}=${encodeURIComponent(serialized)}`;
    })
    .join('&');
};

export const processMainMenuUrls = (mainMenu, navItems) => {
  const navParts = navItems.split('?');
  const navPath = navParts[0];
  const navQuery = navParts[1] ? new URLSearchParams(navParts[1]) : null;

  const itemsValue = navQuery ? navQuery.get('submod_params') : null;
  const modValue = navQuery ? navQuery.get('mod_params') : null;

  let parsedMod = {};
  if (modValue) {
    try {
      parsedMod = JSON.parse(decodeURIComponent(modValue));
    } catch (e) {
      console.warn("Error parsing 'mod_params' for query params", e);
    }
  }

  const { _native, ...modParams } = parsedMod;

  const mustacheContext = { params: modParams };

  mainMenu.forEach((item) => {
    if (item.url) {
      const hasMustache = item.url.includes('{{');
      const renderedUrl = hasMustache
        ? Mustache.render(item.url, mustacheContext)
        : item.url;

      const [itemBase, itemQuery] = renderedUrl.split('?');

      // Collect all extra params to append
      const extraParams = {};

      if (modValue && _native !== false) {
        Object.assign(extraParams, modParams);
      }

      if (itemsValue) {
        extraParams['submod_params'] = itemsValue;
      }

      const cleanBase = itemBase.endsWith('/') ? itemBase : `${itemBase}/`;
      const renderedNavPath = Mustache.render(navPath, mustacheContext);

      // Build query string manually to avoid URLSearchParams over-encoding JSON
      const extraString = serializeQueryParams(extraParams);
      const baseQuery = itemQuery || '';
      const queryString = [baseQuery, extraString].filter(Boolean).join('&');

      item.url = queryString
        ? `${cleanBase}${renderedNavPath}?${queryString}`
        : `${cleanBase}${renderedNavPath}`;
    }
  });
};

export const doLoadDesign = async (url, dispatch) => {
  dispatch(mainInProgress());

  const urlApi = url ? url : SL_MAIN_BACKEND_GET_APP_DESIGN_URL;
  const href = window.location.href;
  const pathname = window.location.pathname;

  let hash = window.location.hash;
  const extracted = extractModuleAndNavItemsFromHash(hash);
  let module = extracted.module;
  let navItems = extracted.navItems;

  const searchParams = new URLSearchParams(window.location.search);
  const modParam = searchParams.get('mod_params');
  const itemsParam = searchParams.get('submod_params');

  let moduleFromUrl = modParam || null;

  let parameters = { href, pathname, hash };

  try {
    await checkLocalSettings();
    if (window.slConfig.app) {
      const app = window.slConfig.app;
      parameters = { ...parameters, app };
    } else {
      let app = buildAppFromHash(hash);
      parameters = { ...parameters, app };
    }
  } catch (error) {
    let app = buildAppFromHash(hash);
    parameters = { ...parameters, app };
  }

  return genericApi
    .post(urlApi, parameters)
    .then((response) => {
      //ICONOS+TEXT - TEXT - ICON - RIGTH MENU
      // const menu = response.data.main_menu.map((item, index) => {
      //   if (index % 2) {
      //     return {
      //       ...item,
      //       image: 'antd:UpCircleOutlined',
      //       alignment: 'right',
      //     };
      //   } else {
      //     if (index === 4) {
      //       return { ...item };
      //     } else if (index === 8) {
      //       return { ...item, image: 'antd:UpCircleOutlined', name: '' };
      //     } else {
      //       return {
      //         ...item,
      //         image: 'antd:UpCircleOutlined',
      //         alignment: 'left',
      //       };
      //     }
      //   }
      // });

      //ICONOS+TEXT - RIGTH MENU
      // const menu = response.data.main_menu.map((item, index) => {
      //   if (index % 2) {
      //     return { ...item, image: 'mdiHome', alignment: 'right' };
      //   } else {
      //     return { ...item, image: 'mdiHome', alignment: 'left' };
      //   }
      // });

      //ICONOS+TEXT
      // const menu = response.data.main_menu.map((item, index) => {
      //   return { ...item };
      // });

      //ONLY ICON
      // const menu = response.data.main_menu.map((item, index) => {
      //   return { ...item, image: 'mdiHome', name: '' };
      // });

      //TOPBANNER
      // response.data.top_banner = {
      //   bg_color: '#FFFFFF',
      //   right_image: 'https://portal.laboratorija.lv/CL_Logos/CL_Banner2.PNG',
      //   left_image: 'https://portal.laboratorija.lv/CL_Logos/CL_Banner1.PNG',
      // };

      // SEARCH;
      // response.data.search = {
      //   url:
      //     '/admin/my_search/?post={"context":{"query":"#QUERY#:#CURRENT_APP#"}}',
      // };

      // response.data.search = {
      //   url: '/system/mirror/?post={"query":"#QUERY# #CURRENT_APP#"}',
      // };

      // SKIN;
      //  response.data.skin_name = 'green';

      if (response.ret === 'ERROR') {
        if (
          urlApi !== SL_MAIN_BACKEND_GET_APP_DESIGN_URL &&
          urlApi !== SL_MAIN_BACKEND_GET_MAIN_DESIGN_URL
        ) {
          dispatch(mainFailed(response));
          return;
        }
      }

      if (navItems && response.data.main_menu) {
        processMainMenuUrls(response.data.main_menu, navItems);
      }

      dispatch(mainSuccess(response.data));
      dispatch(setModules(response.data.main_menu));

      const colors = ['blue', 'grey', 'red', 'green', 'orange'];

      if (response.data.skin_name && colors.includes(response.data.skin_name)) {
        dispatch(setColor(response.data.skin_name.toLowerCase()));
      } else {
        dispatch(setColor('blue'));
      }

      let init = null;

      if (module) {
        init = response.data.main_menu.find(
          (value) => value.url !== '' && value.code === module
        );
      } else if (moduleFromUrl) {
        init = response.data.main_menu.find(
          (value) => value.url !== '' && value.code === moduleFromUrl
        );
      } else {
        init = response.data.main_menu.find(
          (value) => value.url !== '' && value.autoexec
        );
      }

      if (init) {
        const [baseUrl, existingQuery] = init.url.split('?');

        let parsedMod = {};
        if (modParam) {
          try {
            parsedMod = JSON.parse(decodeURIComponent(modParam));
          } catch (e) {
            console.warn(
              '[MainActions] Could not parse `mod_params` URL param:',
              e
            );
          }
        }

        const { _native, ...modParams } = parsedMod;
        const extraParams = {};

        if (modParam && _native !== false) {
          Object.assign(extraParams, modParams);
        }

        if (itemsParam) {
          try {
            extraParams['submod_params'] = JSON.parse(
              decodeURIComponent(itemsParam)
            );
          } catch (e) {
            console.warn(
              '[MainActions] Could not parse `submod_params` URL param:',
              e
            );
          }
        }

        const extraString = serializeQueryParams(extraParams);
        const newQuery = [existingQuery || '', extraString]
          .filter(Boolean)
          .join('&');
        init = { ...init, url: newQuery ? `${baseUrl}?${newQuery}` : baseUrl };

        dispatch(setInitIframe(init));
      }
    })
    .catch((error) => {
      if (
        urlApi === SL_MAIN_BACKEND_GET_APP_DESIGN_URL &&
        error.status === 404
      ) {
        doLoadDesign(SL_MAIN_BACKEND_GET_MAIN_DESIGN_URL, dispatch);
      } else {
        if (error.message === 'unknown_error') {
          error.message = 'Error loading main design';
        }
        dispatch(mainFailed(error));
      }
    });
};

export const checkLocalSettings = async () => {
  const response = await fetch('local-settings/config.json');
  window.slConfig = await response.json();
};

export const openTabIframe = () => {
  if (store.getState().main.iframes.find((value) => value.showPanel)) {
    window.open(
      `${
        API_URL +
        store.getState().main.iframes.find((iframe) => iframe.showPanel).url
      }`,
      '_blank'
    );
  }
};

export const doSetModules = (modules) => (dispatch) => {
  dispatch(setModules(modules));
};

export const doSearch = (value, dispatch) => {
  let urlApi = store.getState().main.data.search.url;

  urlApi = urlApi.replaceAll('#QUERY#', value);

  const activeItem = store.getState().main.activeItem;

  urlApi = urlApi.replaceAll(
    '#CURRENT_APP#',
    activeItem.code ? activeItem.code : ''
  );

  var idAleatorio = Math.floor(Math.random() * 1001);

  const data = {
    // querylibrary: null,
    // query: null,
    // uicmdtreenode: null,
    // uiform: null,
    // uiaction: null,
    // uistage: null,
    // uisecurprivileges: null,
    id: `CUSTOM_QUERY${idAleatorio}`,
    code: `CUSTOM_QUERY${idAleatorio}`,
    name: 'Query',
    pos: 33,
    active: true,
    image: '',
    // type: 'LINK',
    autoexec: false,
    url: urlApi,
    data: '',
    // show_search_bar: false,
    // _model: 'UiModule',
    // search_switches: [],
    showPanel: true,
    refresh: 0,
  };

  dispatch(showIframe(data));
};

export const doShowQuery = (dispatch) => {
  const iframes = store.getState().main.iframes;

  const queries = iframes.filter((value) =>
    value.id.startsWith('CUSTOM_QUERY')
  );

  const data = queries[queries.length - 1];

  dispatch(showIframe(data));
};

const mainInProgress = () => {
  return {
    type: MAIN.IN_PROGRESS,
  };
};
const mainFailed = (error) => {
  return {
    type: MAIN.REJECTED,
    payload: error.message,
    error: true,
  };
};
const mainSuccess = (data) => {
  return {
    type: MAIN.RESOLVED,
    payload: data,
  };
};

export const setInitIframe = (data) => {
  return {
    type: IFRAME.SET_INIT,
    payload: data,
  };
};
export const showIframe = (data) => {
  return {
    type: IFRAME.SHOW,
    payload: data,
  };
};
export const refreshIframe = () => {
  return {
    type: IFRAME.REFRESH,
  };
};
export const duplicateIframe = () => {
  return {
    type: IFRAME.DUPLICATE,
  };
};

export const setModules = (data) => {
  return {
    type: MODULE.SET,
    payload: data,
  };
};
